import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'essenya_token';

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setUser(r.data))
      .catch(() => { setToken(null); localStorage.removeItem(TOKEN_KEY); })
      .finally(() => setLoading(false));
  }, [token]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (nome, email, password) => {
    const r = await axios.post(`${API}/auth/register`, { nome, email, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => { localStorage.removeItem(TOKEN_KEY); setToken(null); setUser(null); };

  const refresh = async () => {
    if (!token) return;
    const r = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
    setUser(r.data);
    return r.data;
  };

  return <AuthContext.Provider value={{ user, token, loading, login, register, logout, refresh, setUser }}>{children}</AuthContext.Provider>;
}
